// just an empty configuration container
export const config = {
  // Your application is responsible for bootstrapping the initial bearer token. If you're using this lib in eSM it'll
  // do that for you, but your test harness will need to bootstrap this.
  bearerToken: ''
};
